"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkPermission = checkPermission;
exports.hasPermission = hasPermission;
exports.checkClaimFilter = checkClaimFilter;
exports.toObjectClaims = toObjectClaims;
const Constants = __importStar(require("./constants"));
const property_1 = require("@genesys/property");
function checkPermission(claims, name, context = Constants.contexts.genesys) {
    return hasClaim(claims, name, "true", context);
}
function hasPermission(claims, name, value, context = Constants.contexts.genesys) {
    return hasClaim(claims, name, value, context);
}
function checkClaimFilter(claims, claimFilter, context = Constants.contexts.genesys) {
    const lowerClaimFilter = property_1.PropertyFilter.fromStringOrEmpty(claimFilter.text.toLowerCase());
    const usedClaims = property_1.PropertyFilter.getReferencedProperties(lowerClaimFilter);
    const variants = getClaimsAsPropertyValues(claims[context], usedClaims.filter(uc => !!claims[context][uc]));
    const starClaims = usedClaims.filter(uc => claims[context][uc] && claims[context][uc].some(c => c === "*"));
    const starLessClaimFilter = property_1.PropertyFilter.fromStringOrEmpty(starClaims.reduce((a, b) => {
        const regex = new RegExp(b + '="(.+?)"', "ig");
        return a.replace(regex, "1=1");
    }, lowerClaimFilter.text));
    return (usedClaims.length === 0 ||
        variants.some(v => property_1.PropertyFilter.isValid(v, starLessClaimFilter)));
}
function hasClaim(claims, name, value, context) {
    const lowerValue = value.toLowerCase();
    const lowerContext = context.toLowerCase();
    const lowerName = name.toLowerCase();
    const values = claims[lowerContext] && claims[lowerContext][lowerName];
    return (values !== undefined &&
        values.some(v => (v.indexOf(";") !== -1 ? v.split(";")[0] : v).toLowerCase() ===
            lowerValue || v === "*"));
}
function getClaimsAsPropertyValues(claims, usedClaims) {
    if (usedClaims.length === 0) {
        return [];
    }
    const firstClaim = usedClaims[0];
    let variants = addValuesToSet(property_1.PropertyValueSet.Empty, firstClaim, claims[firstClaim]);
    const rest = usedClaims.slice(1);
    rest.forEach(uc => {
        let newVariants = [];
        variants.forEach(
        // biome-ignore lint: -
        v => (newVariants = newVariants.concat(addValuesToSet(v, uc, claims[uc]))));
        variants = newVariants;
    });
    return variants;
}
function addValuesToSet(pvs, name, values) {
    return values.map(v => property_1.PropertyValueSet.setText(name, v, pvs));
}
function toObjectClaims(claims) {
    return claims.reduce((soFar, current) => {
        const contextLower = current.context.toLowerCase();
        const contextClaims = soFar[contextLower] || {};
        const newContextClaims = Object.assign(Object.assign({}, contextClaims), { [current.key.toLowerCase()]: current.values });
        return Object.assign(Object.assign({}, soFar), { [contextLower]: newContextClaims });
    }, {});
}
//# sourceMappingURL=claim-validator.js.map